<template>
   <div class="text-input">
      <label><b>{{label}}</b></label>
      <div class="input-group">
        <input type="text" class="form-control"  :disabled="disabled" :placeholder="placeholder"  v-model="displayValue" @input="updateValue" :aria-label="{label}">
      </div>
   </div>
</template>

<script>
export default {
  name: "ZipCodeInput",
  props: ['label', 'placeholder', 'value', 'disabled'],
  data(){
    return{
      displayValue: this.value,
    }
  },
  methods:{
    async updateValue($event){
      await this.numberIsLessThan5digits($event)
      
    },
    numberIsLessThan5digits(event){
      this.setInputFilter(event.srcElement, function (value){
        return /^\d*$/.test(value) && (value === "" || parseInt(value) <= 99999); 
      });
      
    },
    setInputFilter(textbox, inputFilter) {
      ["input", "keydown", "keyup", "mousedown", "mouseup", "select", "contextmenu", "drop"].forEach(function(event) {
        textbox.addEventListener(event, function() {
          if (inputFilter(this.value)) {
            this.oldValue = this.value;
            this.oldSelectionStart = this.selectionStart;
            this.oldSelectionEnd = this.selectionEnd;
          } else if (this.hasOwnProperty("oldValue")) {
            this.value = this.oldValue;
            this.setSelectionRange(this.oldSelectionStart, this.oldSelectionEnd);
          } else {
            this.value = "";
          }
        });
      });
    },
  }, 
  watch: {
    displayValue: function () {
      if(this.displayValue !== null && this.displayValue !== undefined)
      {
        if(this.displayValue.length > 5){
          this.displayValue = this.displayValue.substring(0, this.displayValue.length - 1);
        }        
      }

      this.$emit("input", this.displayValue);
    },
    value: function(){
      this.displayValue = this.value
    }
  },
  
}
</script>

<style lang="scss" scoped>

</style>
